import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-notifications/lib/notifications.css';
import 'font-awesome/css/font-awesome.min.css';
import 'react-select/dist/react-select.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'moment-duration-format';
import 'rc-time-picker/assets/index.css';
import './App.scss';



// WEBPACK FOOTER //
// ./src/vendor.js